import { create } from 'zustand';
export const useStorePhotos = create((set)=>({
    ARR_IMG1 : [],
    ARR_IMG2 : [],
    setARR_IMG1 : (ARR) => set(()=> ({ARR_IMG1 : ARR})),
    setARR_IMG2 : (ARR) => set(()=> ({ARR_IMG2 : ARR})),
}))